import { Box, Skeleton, Stack } from "@mui/material";
import { To } from "react-router";

import { MapPanel } from "~/modules/map/components/MapPanel";

import { TimeReportsHeader } from "./TimeReportsHeader";
import TimeReportsVisitSummarySkeleton from "./TimeReportsVisitSummary/TimeReportsVisitSummarySkeleton";
import { TimeReportsTableHeader } from "./TimeReportTableHeader";
import TimeReportTableRowSkeleton from "./TimeReportTableRow/TimeReportTableRowSkeleton";

type TimeReportsPanelSkeletonProps = {
    backHref: To;
};

export function TimeReportsPanelSkeleton({ backHref }: TimeReportsPanelSkeletonProps) {
    return (
        <MapPanel>
            <TimeReportsHeader backHref={backHref} />

            <Box
                sx={theme => ({
                    display: "grid",
                    gridTemplateColumns: "2fr 1.5fr 1.5fr 1fr",
                    borderBottom: `1px solid ${theme.palette.divider}`,
                })}
            >
                <TimeReportsVisitSummarySkeleton />

                <TimeReportsTableHeader />

                {[1, 2, 3].map(i => (
                    <TimeReportTableRowSkeleton key={i} />
                ))}
            </Box>

            <Stack padding={2} rowGap={2}>
                <Skeleton variant="rectangular" width="100%" height={60} />
                <Skeleton variant="rectangular" width="100%" height={40} />
            </Stack>
        </MapPanel>
    );
}
